export default __webpack_public_path__ + "static/media/puppy-party.83c3bcc6.png";